import Vue from 'vue'
import Router from 'vue-router'
// import productCenter from '../pages/product_center'
import index from '../pages/index'
import aboutUs from '../pages/aboutUs'
import product from '../pages/product'
import userService from '../pages/userService'
import banner1 from '../pages/banner1'

import afterSale from '../pages/pagess/afterSale'
import ApplicationPermission from '../pages/pagess/ApplicationPermission'
import privacyPolicy from '../pages/pagess/privacyPolicy'




import gdd101 from '../pages/pagess/gdd101'
import gdd102 from '../pages/pagess/gdd102'
import gdd103 from '../pages/pagess/gdd103'
import gdd104 from '../pages/pagess/gdd104'
import gdd105 from '../pages/pagess/gdd105'
import gdd106 from '../pages/pagess/gdd106'
import gdd107 from '../pages/pagess/gdd107'
import gdd108 from '../pages/pagess/gdd108'
import gdd109 from '../pages/pagess/gdd109'
import gdd110 from '../pages/pagess/gdd110'
import gdd111 from '../pages/pagess/gdd111'

import gdd113 from '../pages/pagess/gdd113'
import gdd114 from '../pages/pagess/gdd114'
import gdd115 from '../pages/pagess/gdd115'
import gdd116 from '../pages/pagess/gdd116'
import gdd117 from '../pages/pagess/gdd117'
import gdd118 from '../pages/pagess/gdd118'
import gdd119 from '../pages/pagess/gdd119'
import gdd120 from '../pages/pagess/gdd120'
import gdd121 from '../pages/pagess/gdd121'
import gdd122 from '../pages/pagess/gdd122'
import gdd123 from '../pages/pagess/gdd123'
import gdd124 from '../pages/pagess/gdd124'
import gdd125 from '../pages/pagess/gdd125'
import gdd126 from '../pages/pagess/gdd126'
import gdd127 from '../pages/pagess/gdd127'
import gdd128 from '../pages/pagess/gdd128'
import gdd129 from '../pages/pagess/gdd129'
import gdd130 from '../pages/pagess/gdd130'
import gdd131 from '../pages/pagess/gdd131'
import gdd132 from '../pages/pagess/gdd132'
import gdd133 from '../pages/pagess/gdd133'
import gdd134 from '../pages/pagess/gdd134'
import gdd135 from '../pages/pagess/gdd135'
import gdd136 from '../pages/pagess/gdd136'

import mobile_gdd101 from '../pages/pagess/mobile/gdd101'
import aboutUs_mobile from '../pages/pagess/mobile/aboutUs_mobile'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        //banner1
        {
            path: '/banner1',
            name: 'banner1',
            component: banner1
        },

        //应用权限
        {
            path: '/privacyPolicy',
            name: 'privacyPolicy',
            component: privacyPolicy
        },
        //应用权限
        {
            path: '/ApplicationPermission',
            name: 'ApplicationPermission',
            component: ApplicationPermission
        },




        {
            path: '/',
            name: 'index',
            component: index
        },
        // {
        //     path: '/productCenter',
        //     name: 'productCenter',
        //     component: productCenter
        // },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: aboutUs
        }, {
            path: '/product',
            name: 'product',
            component: product
        }, {
            path: '/userService',
            name: 'userService',
            component: userService
        },
        {
            path: '/gdd101',
            name: 'gdd101',

            component: gdd101
        },
        // 360营销页
        {
            path: '/gdd102',
            name: 'gdd102',
            component: gdd102
        },
        // 360营销页
        {
            path: '/gdd103',
            name: 'gdd103',
            component: gdd103
        },
        // 河北天相营销页
        {
            path: '/gdd104',
            name: 'gdd104',
            component: gdd104
        },
        // 河北天相营销页
        {
            path: '/gdd105',
            name: 'gdd105',
            component: gdd105
        },
        //百度的三账户
        {
            path: '/gdd106',
            name: 'gdd106',
            component: gdd106
        },
        // 模仿的页面
        {
            path: '/gdd107',
            name: 'gdd107',
            component: gdd107
        },
        // 模仿的页面2 360   GDD1001
        {
            path: '/gdd108',
            name: 'gdd108',
            component: gdd108
        },
        // 模仿的页面2 360   GDD2001
        {
            path: '/gdd109',
            name: 'gdd109',
            component: gdd109
        },
        // 模仿的页面3 百度   GDD2003
        {
            path: '/gdd110',
            name: 'gdd110',
            component: gdd110
        },
        // 模仿的页面3 百度   GDD2002
        {
            path: '/gdd111',
            name: 'gdd111',
            component: gdd111
        },

        // 360北二下载页面 GDD1001
        {
            path: '/gdd113',
            name: 'gdd113',
            component: gdd113
        },
        //二维码推广 
        {
            path: '/gdd114',
            name: 'gdd114',
            component: gdd114
        },
        //手机号验证码页面 
        {
            path: '/gdd115',
            name: 'gdd115',
            component: gdd115
        },
        //  360  gdd2002
        {
            path: '/gdd116',
            name: 'gdd116',
            component: gdd116
        },
        //第二版设计顶部带按钮页面  上海推广用   cf1  gdd2001  
        {
            path: '/gdd117',
            name: 'gdd117',
            component: gdd117
        },
        //   360  gdd2003
        {
            path: '/gdd118',
            name: 'gdd118',
            component: gdd118
        },
        //   360  gdd2002  下载按钮点击
        {
            path: '/gdd119',
            name: 'gdd119',
            component: gdd119
        },
        //   360 展示广告投放  gdd1001  
        {
            path: '/gdd120',
            name: 'gdd120',
            component: gdd120
        },
        //   baidu   gdd1001  
        {
            path: '/gdd121',
            name: 'gdd121',
            component: gdd121
        },
        {
            path: '/gdd122',
            name: 'gdd122',
            component: gdd122
        },
        {
            path: '/gdd123',
            name: 'gdd123',
            component: gdd123
        },
        //360 12号账户  展示广告  下载    2001的包
        {
            path: '/gdd124',
            name: 'gdd124',
            component: gdd124
        }, //360 12号账户  展示广告  下载    2002的包
        {
            path: '/gdd125',
            name: 'gdd125',
            component: gdd125
        }, {
            path: '/gdd126',
            name: 'gdd126',
            component: gdd126
        }, {
            path: '/gdd127',
            name: 'gdd127',
            component: gdd127
        }, {
            path: '/gdd128',
            name: 'gdd128',
            component: gdd128
        }, {
            path: '/gdd129',
            name: 'gdd129',
            component: gdd129
        }, {
            path: '/gdd130',
            name: 'gdd130',
            component: gdd130
        }, {
            path: '/gdd131',
            name: 'gdd131',
            component: gdd131
        }, {
            path: '/gdd132',
            name: 'gdd132',
            component: gdd132
        }, {
            path: '/gdd133',
            name: 'gdd133',
            component: gdd133
        }, {
            path: '/gdd134',
            name: 'gdd134',
            component: gdd134
        }, {
            path: '/gdd135',
            name: 'gdd135',
            component: gdd135
        }, {
            path: '/gdd136',
            name: 'gdd136',
            component: gdd136
        },
        {
            path: '/mobile_gdd101',
            name: 'mobile_gdd101',
            component: mobile_gdd101
        },
        // 移动端关于我们页面
        {
            path: '/aboutUs_mobile',
            name: 'aboutUs_mobile',
            component: aboutUs_mobile
        },

        // 售后页面
        {
            path: '/afterSale',
            name: 'afterSale',
            component: afterSale
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }

})


// WEBPACK FOOTER //
// ./src/router/index.js